import { Link } from 'react-router-dom';
import { BrandLS } from '../_BrandLS';
import { BrandLink } from '../../_Shared/BrandLink';

const BLOCK = 'LStudio__app_footer';

export const FooterPublic = ({ brand, columns = [], legal, showBrandLS = false, isPrivate = false }) => {

    const SLOT = isPrivate ? brand?.footerPrivate : brand?.footerPublic;

    return (

    <footer className={BLOCK}>

        <div className={`${BLOCK}__grid`}>

            <div className={`${BLOCK}__brand_col`}>

                <BrandLink slot={SLOT} homePath={SLOT?.internalLink ?? "/"} className={`${BLOCK}__brand`} isLogo={SLOT?.isLogo === true}>

                    {SLOT?.isLogo && SLOT?.logoLight && (
                        <img src={SLOT.logoLight} alt={SLOT?.alt ?? ""} title={SLOT?.title ?? ""}
                            className={`${BLOCK}__logo ${BLOCK}__logo--light`}
                            onError={(e) => { e.currentTarget.style.display = "none"; }} />
                    )}

                    {SLOT?.isLogo && SLOT?.logoDark && (
                        <img src={SLOT.logoDark} alt={SLOT?.alt ?? ""} title={SLOT?.title ?? ""}
                            className={`${BLOCK}__logo ${BLOCK}__logo--dark`}
                            onError={(e) => { e.currentTarget.style.display = "none"; }} />
                    )}

                    {!SLOT?.isLogo && <span className={`${BLOCK}__title`}>{brand?.name}</span>}

                </BrandLink>

                {brand?.claim && <p className={`${BLOCK}__claim`}>{brand.claim}</p>}
            </div>

            {
                columns.map((col) => (
                    <div key={col.title}>
                        <p className={`${BLOCK}__title`}>{col.title}</p>
                        {
                            col.items.map((item) => (
                                <Link key={item.path} to={item.path} className={`${BLOCK}__link`}>
                                    {item.label}
                                </Link>
                            ))
                        }
                    </div>
                ))
            }

        </div>

        <div className={`${BLOCK}__bottom`}>{legal}</div>

        {/* 🔥 Marca FIJA del autor del template. Nada que ver con la del cliente. */}
        {showBrandLS && <BrandLS />}

    </footer>
    );
};